import { inject, Pipe, PipeTransform } from '@angular/core';

import { TOptions } from 'i18next';

import { BaasI18n } from '@lvflanders/bar';

@Pipe({
    name: 'i18n',
    standalone: true
})
export class BarI18nPipe implements PipeTransform {
    readonly #i18n = inject(BaasI18n);

    transform(value: string, ...args: unknown[]): any {
        const params: TOptions<any> = args && args.length ? (args[0] as TOptions<any>) : {};
        return this.#i18n.get(value, params);
    }
}
